import { SVGAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

function Send({ width = 20, height = 20, className, ...rest }: SVGAttributes<SVGElement>) {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      {...rest}
      className={twMerge('', className)}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.109 2.058a.625.625 0 01.15.64l-5 15a.625.625 0 01-1.151.081l-3.24-6.48-6.48-3.24a.625.625 0 01.081-1.152l15-5a.625.625 0 01.64.151zm-8.015 8.899l2.457 4.914 4.128-12.383L3.296 7.616l4.914 2.457 2.598-2.598a.625.625 0 01.884.884l-2.598 2.598z"
        fill="#656565"
      />
    </svg>
  );
}

export default Send;
